<template>
  <CRow>

    <GmapMap
        :center="location"
        :zoom="15"
        map-type-id="terrain"
        style="width: 100%; height: 800px"
        >

        <GmapMarker
            :key="'m0'"
            :position="location"
            :clickable="true"
            @click="infoWinOpen = true"
        />

        <gmap-info-window  
            :position="location"
            :options="infoOptions"
            :opened="infoWinOpen"
             >
        </gmap-info-window>

        </GmapMap>
  </CRow>
</template>

<script>
import mapData from './land_price';
import cartData from './cart';

export default {
  name: 'LocationViewer',
  data () {
    return {
        infoWinOpen: false,
        infoOptions: {
            content: 'demo'
        },
        location: {
            lat: 0,
            lng: 0
        },
        markers: [],
    }
  },
  watch: {

  },
  methods: {
  },
  mounted () {
      this.location.lat = parseFloat(this.$route.query.lat);
      this.location.lng = parseFloat(this.$route.query.lng);
      this.infoOptions.content = this.$route.query.title;
  }
}
</script>

<style scoped>
</style>
